var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_614_71384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.46094 6.66666H3.33594V11.3333H5.46094V6.66666Z",
    fill: "#585AD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 6.66666H7.9375V11.3333H10.0625V6.66666Z",
    fill: "#585AD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0846 12.6667H1.91797V14.6667H16.0846V12.6667Z",
    fill: "#585AD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.668 6.66666H12.543V11.3333H14.668V6.66666Z",
    fill: "#585AD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0013 0.666656L1.91797 3.99999V5.33332H16.0846V3.99999L9.0013 0.666656Z",
    fill: "#585AD7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_614_71384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.f78cd76034df0ff36ad5ba31a9bef205.svg";
export { ForwardRef as ReactComponent };